var map = {
	"./13412.jpg": "BC53"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ziGm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/makes nonrecursive \.jpg$
// module id = ziGm
// module chunks = 1